import { getIconSize } from '../../../theme/icons/utils';
import { iconColorMapping } from './_BaseIcon.types';
export var baseIconTheme = {
  baseStyle: _ref => {
    var {
      isInverted
    } = _ref;
    return {
      display: 'inline-flex',
      borderRadius: 's',
      outlineColor: 'transparent',
      transition: 'outline-color 0.2s',
      _readOnly: {
        color: 'neutral.darker',
        '&[data-is-brand-color="true"]': {
          opacity: 0.6,
          color: iconColorMapping['brand']
        }
      },
      _disabled: {
        color: 'neutral.light',
        '&[data-is-brand-color="true"]': {
          opacity: 0.35,
          color: iconColorMapping['brand']
        }
      },
      _focusVisible: {
        outlineColor: "focus.".concat(isInverted ? 'invert' : 'focus'),
        outlineWidth: '2px',
        outlineOffset: '2px',
        outlineStyle: 'solid'
      }
    };
  },
  sizes: {
    'extra-small': getIconSize,
    small: getIconSize,
    'small-medium': getIconSize,
    medium: getIconSize,
    large: getIconSize,
    'extra-large': getIconSize
  },
  defaultProps: {
    size: 'small'
  }
};
//# sourceMappingURL=_BaseIcon.theme.js.map